import consumer from "./consumer"

// Customer Queue Channel for public queue tracking
// This channel allows customers to receive real-time updates about their service queue status

const CustomerQueueChannel = {
  subscription: null,
  queueId: null,
  
  subscribe(queueId, callbacks = {}) {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
    
    this.queueId = queueId
    
    this.subscription = consumer.subscriptions.create(
      { channel: "CustomerQueueChannel", queue_id: queueId },
      {
        connected() {
          console.log(`CustomerQueueChannel: Connected to queue ${queueId}`)
          if (callbacks.onConnected) callbacks.onConnected()
        },

        disconnected() {
          console.log('CustomerQueueChannel: Disconnected')
          if (callbacks.onDisconnected) callbacks.onDisconnected()
        },
        
        rejected() {
          console.log('CustomerQueueChannel: Subscription rejected')
          if (callbacks.onRejected) callbacks.onRejected()
        },

        received(data) {
          console.log('CustomerQueueChannel: Received', data)
          if (callbacks.onReceived) callbacks.onReceived(data)
        }
      }
    )
    
    return this.subscription
  },
  
  unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe()
      this.subscription = null
    }
  }
}

// Export for use in views
window.CustomerQueueChannel = CustomerQueueChannel

export default CustomerQueueChannel
